import {HORACHECKOUT} from "../Constantes";

export const obtenerFechaEstandarCheckOut = (dateTime) => {

    let fecha = new Date(dateTime)
    let fechaStandar = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), HORACHECKOUT).getTime()

    return fechaStandar
}